"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: check-deposit/errors.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcheck-deposit%2Ferrors.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodeToJSON = exports.errorCodeFromJSON = exports.ErrorCode = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.checkdeposit.proto';
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["VERIFIED_EMAIL_REQUIRED"] = "VERIFIED_EMAIL_REQUIRED";
    ErrorCode["VERIFIED_PHONE_REQUIRED"] = "VERIFIED_PHONE_REQUIRED";
    ErrorCode["NOT_ENROLLED"] = "NOT_ENROLLED";
    ErrorCode["CHECK_REJECTED"] = "CHECK_REJECTED";
    ErrorCode["INVALID_DEPOSIT_DESTINATION"] = "INVALID_DEPOSIT_DESTINATION";
    ErrorCode["DUPLICATE_CHECK_FOR_REFERENCE"] = "DUPLICATE_CHECK_FOR_REFERENCE";
    ErrorCode["ACCOUNT_OVERDRAWN"] = "ACCOUNT_OVERDRAWN";
    ErrorCode["TOO_MANY_CHECK_RETURNS"] = "TOO_MANY_CHECK_RETURNS";
    ErrorCode["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
    ErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
function errorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'VERIFIED_EMAIL_REQUIRED':
            return ErrorCode.VERIFIED_EMAIL_REQUIRED;
        case 1:
        case 'VERIFIED_PHONE_REQUIRED':
            return ErrorCode.VERIFIED_PHONE_REQUIRED;
        case 2:
        case 'NOT_ENROLLED':
            return ErrorCode.NOT_ENROLLED;
        case 3:
        case 'CHECK_REJECTED':
            return ErrorCode.CHECK_REJECTED;
        case 4:
        case 'INVALID_DEPOSIT_DESTINATION':
            return ErrorCode.INVALID_DEPOSIT_DESTINATION;
        case 5:
        case 'DUPLICATE_CHECK_FOR_REFERENCE':
            return ErrorCode.DUPLICATE_CHECK_FOR_REFERENCE;
        case 6:
        case 'ACCOUNT_OVERDRAWN':
            return ErrorCode.ACCOUNT_OVERDRAWN;
        case 7:
        case 'TOO_MANY_CHECK_RETURNS':
            return ErrorCode.TOO_MANY_CHECK_RETURNS;
        case 8:
        case 'NOT_ELIGIBLE':
            return ErrorCode.NOT_ELIGIBLE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ErrorCode.UNRECOGNIZED;
    }
}
exports.errorCodeFromJSON = errorCodeFromJSON;
function errorCodeToJSON(object) {
    switch (object) {
        case ErrorCode.VERIFIED_EMAIL_REQUIRED:
            return 'VERIFIED_EMAIL_REQUIRED';
        case ErrorCode.VERIFIED_PHONE_REQUIRED:
            return 'VERIFIED_PHONE_REQUIRED';
        case ErrorCode.NOT_ENROLLED:
            return 'NOT_ENROLLED';
        case ErrorCode.CHECK_REJECTED:
            return 'CHECK_REJECTED';
        case ErrorCode.INVALID_DEPOSIT_DESTINATION:
            return 'INVALID_DEPOSIT_DESTINATION';
        case ErrorCode.DUPLICATE_CHECK_FOR_REFERENCE:
            return 'DUPLICATE_CHECK_FOR_REFERENCE';
        case ErrorCode.ACCOUNT_OVERDRAWN:
            return 'ACCOUNT_OVERDRAWN';
        case ErrorCode.TOO_MANY_CHECK_RETURNS:
            return 'TOO_MANY_CHECK_RETURNS';
        case ErrorCode.NOT_ELIGIBLE:
            return 'NOT_ELIGIBLE';
        case ErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.errorCodeToJSON = errorCodeToJSON;
//# sourceMappingURL=errors.js.map